window.onload = function () {
  function doSomething() {
    var ratings = document.querySelectorAll(
      ".spr-starratings .spr-icon.spr-icon-star"
    );
    var ratingsEmpty = document.querySelectorAll(
      ".spr-starratings .spr-icon.spr-icon-star-empty, .Icon--rating-heart.rating__star--empty"
    );
    for (var i = 0, len = ratings.length; i < len; i++) {
      //work with ratings[i]
      ratings[i].insertAdjacentHTML(
        "afterend",
        '<svg enable-background="new 0 0 122.88 107.41" viewBox="0 0 122.88 107.41" width="14" height="14" class="Icon Icon--rating-heart rating__star rating__star--full"><path d="m60.83 17.19c8.01-8.35 13.62-15.57 25.96-16.98 23.17-2.66 44.48 21.06 32.78 44.41-3.33 6.65-10.11 14.56-17.61 22.32-8.23 8.52-17.34 16.87-23.72 23.2l-17.4 17.26-14.38-13.84c-17.3-16.66-45.51-37.63-46.44-63.61-.65-18.2 13.71-29.86 30.23-29.65 14.76.2 20.97 7.54 30.58 16.89z" fill="currentColor"></path></svg>'
      );
      ratings[i].remove();
    }
    for (var i = 0, len = ratingsEmpty.length; i < len; i++) {
      //work with ratingsEmpty[i]
      ratingsEmpty[i].insertAdjacentHTML(
        "afterend",
        '<svg width="20" height="20" fill-rule="evenodd" clip-rule="evenodd" class="Icon Icon--rating-heart rating__star rating__star--empty" x="0px" y="0px" viewBox="0 0 471.7 471.7" style="enable-background:new 0 0 471.7 471.7;" xml:space="preserve"> <path d="M433.6,67c-24.7-24.7-57.4-38.2-92.3-38.2s-67.7,13.6-92.4,38.3L236,80l-13.1-13.1c-24.7-24.7-57.6-38.4-92.5-38.4 c-34.8,0-67.6,13.6-92.2,38.2C13.5,91.4-0.1,124.2,0,159.1c0,34.9,13.7,67.6,38.4,92.3l187.8,187.8c2.6,2.6,6.1,4,9.5,4 s6.9-1.3,9.5-3.9l188.2-187.5c24.7-24.7,38.3-57.5,38.3-92.4C471.8,124.5,458.3,91.7,433.6,67L433.6,67z M414.4,232.7l-178.7,178 L57.4,232.4C37.8,212.8,27,186.8,27,159.1s10.7-53.7,30.3-73.2c19.5-19.5,45.5-30.3,73.1-30.3c27.7,0,53.8,10.8,73.4,30.4l22.6,22.6 c5.3,5.3,13.8,5.3,19.1,0l22.4-22.4c19.6-19.6,45.7-30.4,73.3-30.4s53.6,10.8,73.2,30.3c19.6,19.6,30.3,45.6,30.3,73.3 C444.8,187.1,434,213.1,414.4,232.7z"></path></svg>'
      );
      ratingsEmpty[i].remove();
    }
  }
  setTimeout(doSomething, 1000); 
};